var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_188400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 18.0592C4.87657 17.3219 6.3251 16.9338 7.79961 16.9338C9.27412 16.9338 10.7226 17.3219 11.9996 18.0592C13.2766 17.3219 14.7251 16.9338 16.1996 16.9338C17.6741 16.9338 19.1226 17.3219 20.3996 18.0592",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 5.92538C4.87657 5.18812 6.3251 4.79999 7.79961 4.79999C9.27412 4.79999 10.7226 5.18812 11.9996 5.92538C13.2766 5.18812 14.7251 4.79999 16.1996 4.79999C17.6741 4.79999 19.1226 5.18812 20.3996 5.92538",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 5.92517V18.0585",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.92517V18.0585",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4004 5.92517V18.0585",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_188400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookBlack);
export default __webpack_public_path__ + "static/media/icon_book_black.b0eb58a744d05bc08310e0713391293c.svg";
export { ForwardRef as ReactComponent };